import React, { useEffect, useState } from 'react';
import { tokenManager, regionManager, apiService } from '../services/api';
import WPMLogo from '../components/WPMLogo';

const LoginCallback: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      const errorParam = params.get('error');

      if (errorParam) {
        let errorMessage = 'Microsoft authentication failed. Please try again.';
        switch (errorParam) {
          case 'no_code':
            errorMessage = 'No authorization code received from Microsoft.';
            break;
          case 'config_error':
            errorMessage = 'Microsoft OAuth is not properly configured.';
            break;
          case 'auth_failed':
            errorMessage = 'Microsoft authentication failed.';
            break;
          case 'no_email':
            errorMessage = 'Could not retrieve email from Microsoft account.';
            break;
          case 'server_error':
            errorMessage = 'Server error during authentication.';
            break;
          case 'invalid_state':
            errorMessage = 'Invalid or expired authentication request.';
            break;
        }
        setError(errorMessage);
        setTimeout(() => {
          window.location.href = '/login';
        }, 3000);
        return;
      }

      if (!token) {
        setError('No authentication token received. Please try again.');
        setTimeout(() => {
          window.location.href = '/login';
        }, 3000);
        return;
      }

      // Store token before any API calls
      tokenManager.setToken(token);

      // Brief delay to ensure token is fully stored before making API calls
      await new Promise(resolve => setTimeout(resolve, 100));

      try {
        await apiService.checkAuth();

        const region = regionManager.getRegion();
        if (!region) {
          setError('Please select a region.');
          tokenManager.removeToken();
          setTimeout(() => {
            window.location.href = '/login';
          }, 2000);
          return;
        }

        window.location.replace('/');
      } catch (err) {
        setError('Authentication failed. Please try again.');
        tokenManager.removeToken();
        setTimeout(() => {
          window.location.href = '/login';
        }, 3000);
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-600 to-purple-800 p-5">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl p-10 shadow-2xl">
          <div className="text-center">
            <div className="flex justify-center mb-6">
              <WPMLogo size={48} />
            </div>
            {error ? (
              <>
                <div className="text-red-600 text-xl font-bold mb-4">⚠️ Authentication Error</div>
                <p className="text-gray-600">{error}</p>
                <p className="text-sm text-gray-500 mt-4">Redirecting to login...</p>
              </>
            ) : (
              <>
                <div className="text-purple-600 text-xl font-bold mb-4">✓ Authentication Successful</div>
                <p className="text-gray-600">Redirecting to dashboard...</p>
                <div className="mt-6">
                  <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginCallback;
